module.exports = __webpack_public_path__ + "img/gt.eebb73ee.svg";